export const sides = ["BUY", "SELL"];
